import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-06-14'
        tag='Facebook Marketplace'
        title='Supercharge your businesses with Facebook Marketplace offers'
      >
        <p>
          Sending an offer on reselling platforms typically means a buyer is offering an amount lower than the listing
          price and submitting it to the seller for consideration.
        </p>
        <p>
          On Facebook Marketplace, this type of negotiation is possible if the seller opts in to allow offers from
          interested parties. The seller can then accept, decline, or send a counter-offer.
        </p>
        <p>
          An accepted offer doesn't automatically mean the item is already sold to the buyer who made the offer. The
          seller is not obliged to mark the item as sold until the buyer pays for it at the agreed price. This way, the
          item is still listed and available to others in case the negotiation falls through.
        </p>
        <p>
          With the knowledge that most potential buyers tend to bargain, you should factor in an extra 20%- 40% into
          your listing prices. If you're willing to let go of a dress for $20, list it anywhere between $24 to $28 to
          make room for buyers' offers below these prices. Doing this would also allow you to draw the line on a
          low-ball offer – in this case, anything less than $20.{' '}
        </p>
        <p>
          Although accepting reasonable offers this way is fine, sellers should consider proactive ways to attract more
          buyers and make more sales.
        </p>

        <h3>Attract buyers with these seller offers</h3>
        <p>
          Facebook Marketplace allows sellers to highlight all or selected items from their catalogs or collections – or
          only specific products – with a discounted price or a special deal through Commerce Manager.
        </p>
        <p>
          You may choose from the following kinds of offers. Here, we discuss the restrictions and the purchase
          requirements that would make a customer eligible to enjoy each of these promotions.
        </p>
        <p>
          <strong>1. Amount Off.</strong> Offer to reduce prices by a certain percentage or slash a specific amount of
          the listing price.
        </p>
        <ul>
          <li>
            Customers must meet the minimum subtotal or minimum quantity of purchase, the values of which are determined
            by the seller upon setting up the offer preferences.
          </li>
          <li>
            Tiered minimums, the third kind of purchase requirement, are also an available option. Customers must meet
            at least two minimum subtotal or minimum quantity levels. Note that if this purchase requirement is
            selected, the amount off will automatically be in the form of a percentage. To read more on this, you may go{' '}
            <a href='https://www.facebook.com/business/help/718380518775632'>here</a>.
          </li>
          <li>The use of this type of offer is limited to only once per order or item.</li>
          <li>Tax will be calculated based on the reduced amount.</li>
          <li>You have the option to exclude discounted or sale items in your catalog from this offer.</li>
          <li>You may implement it in tandem with Free Shipping or Buy X Get Y.</li>
        </ul>
        <p>
          <strong>2. Free Shipping.</strong> Offer to shoulder the shipping fee for customers who meet the required
          minimum subtotal or quantity. You may offer customers one or more shipping options. This promotion may be
          combined with Amount Off or Buy X Get Y to make it more compelling to customers.
        </p>
        <p>
          <strong>3. Buy X Get Y.</strong> Offer customers the option to enjoy Free Shipping, Amount Off, or a certain
          item free of charge if they meet the minimum quantity purchase requirement. You have the choice to exclude
          discounted or sale items in your catalog from this offer.
        </p>
        <p>
          Apart from these three options, you can also consider offering <strong>promo codes</strong> to your buyers.
          These promo codes can be either <strong>public</strong> (displayed on your shop page and automatically applied
          upon checkout if entered within your specified duration) or <strong>secret</strong> (surreptitiously disclosed
          in your page or item description and need to be manually entered by the buyer upon checkout).
        </p>
        <p>
          If you haven't tried any of these offer types yet, you may want to implement one at a time to see which one
          yields the best results for you.
        </p>

        <h3>Setting up seller offers in Commerce Manager</h3>
        <p>
          First off, ensure that you have already enabled your Commerce Manager's Catalog and Promotions permissions.
        </p>
        <p>
          Next, locate <strong>Offers</strong> under the <strong>Promotions tab</strong>, and from there, go to{' '}
          <strong>Create Offers</strong>. Choose the type of offer you'd like to try from the selection discussed above.
          Decide if you would like this offer to apply to your entire catalog or specific items only.
        </p>
        <p>
          You will then be prompted to assign an internal name for this particular offer. This name will only be visible
          to you.
        </p>
        <p>
          Then, make sure to select the appropriate purchase requirement/s (minimum subtotal, minimum quantity, or
          tiered minimums) and determine a specific value if you need to set a minimum spend.
        </p>
        <p>
          As mentioned earlier, you may exclude sale items from your offers. Don't forget to select the items you are
          excluding. Otherwise, the promotion will automatically apply to these as well.
        </p>
        <p>
          Another important detail is duration. You need to set the time frame during which your offer remains valid. If
          you need to end this offer prematurely, you can do so.
        </p>
        <p>
          Finally, ensure that everything is in order. Hit <strong>Preview All</strong> and double-check to see that
          your desired details are reflected before clicking <strong>Create Offer</strong>.
        </p>
        <p>
          If you need to make any edits to the details of your offer, you may do so. You can also feature this offer in
          your shop or include it in your live shopping videos to attract more potential buyers.
        </p>

        <h3>Going the extra mile to grow your business</h3>
        <p>
          As a player in a competitive selling platform like Facebook Marketplace, you need to be in the know of the
          latest features available – such as the exciting offers and promotions mentioned earlier – to help you boost
          your sales.
        </p>
        <p>
          It also pays to be open to trying reliable external tools that help streamline your operations and increase
          your productivity. OneShop, in particular, is trusted by thousands of resellers for its superb automation
          functions and more. Its main selling points are the automated cross-listing and delisting functions, allowing
          multi-site sellers to increase their listings' exposure without taking up too much time.
        </p>
        <p>
          Don't miss the opportunity to scale up your business with OneShop today!{' '}
          <a href='https://tools.oneshop.com/signup'>Sign-up here</a> to enjoy a 7-day free trial and take advantage of
          the benefits it can give you.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
